import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "fullModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "newPostTitle afterButton" }
const _hoisted_5 = { class: "postContainer d-flex flex-column" }
const _hoisted_6 = { class: "d-block" }
const _hoisted_7 = { class: "postContainer" }
const _hoisted_8 = { class: "postLoader w-100" }
const _hoisted_9 = { class: "my-4 w-100" }
const _hoisted_10 = { class: "groupName mb-3" }
const _hoisted_11 = { class: "d-flex align-items-center flex-column justify-content-between" }
const _hoisted_12 = { class: "d-flex justify-content-center flex-column align-items-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "backbutton",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_cerca',
          text: 'Cerca'
        })
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("span", _hoisted_6, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_cerca',
          text: 'Cerca'
        })
      ]),
      _withDirectives(_createVNode("input", {
        class: "w-50",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localSearch.searchText = $event))
      }, null, 512), [
        [_vModelText, _ctx.localSearch.searchText]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_localized_text, {
              class: "text_uppercase",
              localizedKey: "app_filtrapertopic",
              text: "Filtra per topic"
            })
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("button", {
              type: "button",
              class: ["btn btn-large mx-2 mt-3 mb-2", _ctx.localSearch.tags.length == 0 ? 'btn-blue':'btn-blue-hollow'],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.localSearch.tags = []))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: 'app_tuttiitopic',
                text: 'Tutti i topic'
              })
            ], 2)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "d-flex align-items-center justify-content-between border_grey_bottom",
              key: index
            }, [
              _createVNode("button", {
                type: "button",
                class: ["community_filter_topic btn btn-large mr-2 mt-3 mb-2", _ctx.getTagClass(tag)],
                onClick: ($event: any) => (_ctx.editTags(tag))
              }, _toDisplayString(tag.tag), 11, ["onClick"]),
              _createVNode("div", null, [
                _createVNode(_component_toggler, {
                  value: _ctx.followedTags.indexOf(tag.identifier) > -1,
                  onInput: ($event: any) => (_ctx.setSubscription($event, tag.identifier))
                }, null, 8, ["value", "onInput"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-large btn-blue",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          class: "text_uppercase",
          localizedKey: "app_chiudi",
          text: "Chiudi"
        })
      ]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-large btn-blue mt-3",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.next()))
      }, [
        _createVNode(_component_localized_text, {
          class: "text_uppercase",
          localizedKey: "app_cerca",
          text: "Cerca"
        })
      ])
    ])
  ]))
}